// Shared error types and base error class for Airtable modules

export enum AirtableErrorType {
  // API-level errors
  AUTHENTICATION = 'authentication',
  RATE_LIMIT = 'rate_limit',
  PERMISSION = 'permission',
  NOT_FOUND = 'not_found',
  VALIDATION = 'validation',
  
  // Application-level errors
  NETWORK = 'network',
  TIMEOUT = 'timeout',
  PARSING = 'parsing',
  CACHING = 'caching',
  
  // Generic fallbacks
  SERVER = 'server',
  CLIENT = 'client',
  UNKNOWN = 'unknown'
}

export enum ErrorSeverity {
  INFO = 'info',
  WARNING = 'warning',
  ERROR = 'error',
  CRITICAL = 'critical'
}

export class AirtableError extends Error {
  type: AirtableErrorType;
  severity: ErrorSeverity;
  timestamp: Date;
  originalError?: Error | unknown;
  context?: Record<string, any>;

  constructor(
    message: string, 
    type: AirtableErrorType = AirtableErrorType.UNKNOWN,
    severity: ErrorSeverity = ErrorSeverity.ERROR,
    originalError?: Error | unknown,
    context?: Record<string, any>
  ) {
    super(message);
    this.name = 'AirtableError';
    this.type = type;
    this.severity = severity;
    this.timestamp = new Date();
    this.originalError = originalError;
    this.context = context;
  }

  toJSON() {
    return {
      name: this.name,
      message: this.message,
      type: this.type,
      severity: this.severity,
      timestamp: this.timestamp,
      originalError: this.originalError instanceof Error ? {
        name: this.originalError.name,
        message: this.originalError.message,
        stack: this.originalError.stack
      } : this.originalError,
      context: this.context
    };
  }
} 